import { matchPath, useLocation } from 'react-router-dom';
import { UseMatchPattern } from './types';

export default function useMatchesAny(patterns: UseMatchPattern[]) {
  const location = useLocation();
  return patterns.some((pattern) => matchPath(pattern, location.pathname));
}
